import React from "react";

import SuggestedFriends from "../friends/SuggestedFriends";

const SidebarRight = () => {
  return (

    <div className="space-y-4">

      <SuggestedFriends />

    </div>

  );
};

export default SidebarRight;